<div mainpanel>
  <div toolbar>
    <div>
      @for (site of globals.sites; track $index) {
        <button (click)="globals.appSite=site.id"
                [class]="site.id === globals.appSite ? 'current': ''"
                btn-site
                mat-button>
          <img alt="appicon" class="appicon" src="../../../assets/images/site-{{site.id}}.png">
        </button>
      }
    </div>
    <div>
      <button [matMenuTriggerFor]="menu" mat-button>
        <img alt="appicon" class="appicon" src="../../../assets/themes/standard/favicon.png">
      </button>
      <mat-menu #menu="matMenu" xPosition="before">
        <button (click)="clickWhatsNew()" mat-menu-item>
          <mat-icon>info_outline</mat-icon>
        </button>
        <button (click)="clickImpressum()" mat-menu-item>
          <mat-icon>account_balance</mat-icon>
        </button>
        <button (click)="clickWelcome()" mat-menu-item>
          <mat-icon>school</mat-icon>
        </button>
        <div *ngFor="let item of ls.languageList; let idx = index" class="btnLanguage">
          <button (click)="clickLanguage(item)" [class]="languageClass(item)" mat-icon-button>
            <img alt="language image" class="language" src="{{item.imgPath}}">
          </button>
          <a *ngIf="item.crowdin != null" [href]="item.crowdin.languageUrl" class="crowdin" target="_blank" title="Crowdin">
            <img [src]="item.crowdin.languageBadgeUrl" alt="{{item.crowdin.langName}} proofreading">
          </a>
        </div>
      </mat-menu>
    </div>
    <div>
      <button (click)="clickDebug($event)" *ngIf="globals.mayDebug" class="debug" mat-icon-button>
        <mat-icon>{{ globals.isDebug ? 'pest_control' : 'bug_report' }}</mat-icon>
      </button>
      <button (click)="sync.toggleSyncDropbox()" id="sync" mat-icon-button>
        <ng-container *ngIf="!sync.hasSync">
          <mat-icon>sync_disabled</mat-icon>
        </ng-container>
        <ng-container *ngIf="sync.hasSync">
          <img alt="dropbox" src="../../../assets/images/dropbox.png">
        </ng-container>
      </button>
    </div>
  </div>
  <div [class]="globals.appSite" content>
    @switch (globals.appSite) {
      @case ('thumb') {
        <app-site-thumbling></app-site-thumbling>
      }
      @case ('prime') {
        <app-site-prime-numbers></app-site-prime-numbers>
      }
      @case ('rubik') {
        <app-site-rubik></app-site-rubik>
      }
      @case ('pdf') {
        <app-site-pdf></app-site-pdf>
      }
      @case ('collatz') {
        <app-site-collatz></app-site-collatz>
      }
      @case ('puzzlendar') {
        <app-site-puzzlendar></app-site-puzzlendar>
      }
      @case ('lotto') {
        <app-site-lotto></app-site-lotto>
      }
      @case ('tacta') {
        <app-site-tacta></app-site-tacta>
      }
    }
  </div>
</div>
<app-progress></app-progress>
<div hidden id="mark"></div>
